<template>
  <div>
    <v-card>
      <v-toolbar elevation="8" density="compact">
        <v-toolbar-title>Support Tools</v-toolbar-title>
      </v-toolbar>
      <v-banner bg-color="red" class="white--text" v-if="impersonatedRoles.length">
        
        <template v-slot:text>
          <h5>Mocked Roles</h5>
          <p>{{ impersonatedRoles }}</p>
        </template>
        <template v-slot:actions>
          <v-btn variant="text"  class="text-button white--text" elevation="0" @click="clearImpersonatedRoles">Clear mocked roles</v-btn>
        </template>
      </v-banner>
      <v-container fluid>
        <v-row justify="space-around">
          <v-col cols="12">
            <v-dialog v-model="taskRelationshipReport" persistent max-width="400">
              <template v-slot:activator="{ props: activatorProps }">
                <v-btn v-bind="activatorProps" color="orange-darken-1" class="ma-2">Task Relationship Report</v-btn>
              </template>
              <v-card>
                <v-toolbar color="blue-lighten-4" height="40" window>
                  <span></span>
                  <v-spacer></v-spacer>
                  <v-btn @click="taskRelationshipReport = false" icon>
                    <v-icon color="error">mdi-close-circle-outline</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-container>
                  <v-row dense>
                    <v-col v-if="currentQuestions && questionsComplete">
                      <v-btn :loading="fatReportLoading" small color="secondary" @click="downloadFATRelationshipReport"
                        >Export Task Relationship Loaded in Form</v-btn
                      >
                    </v-col>
                  </v-row>
                  <v-row dense v-if="currentQuestions">
                    <v-col>
                      <v-btn
                        :loading="taskRelationshipReportLoading"
                        small
                        class="my-2"
                        color="secondary"
                        @click="downloadTaskRelationshipReport"
                        >Export Task Relationship Report</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col
            cols="12"
            v-if="
              adminRoles.findIndex(
                (role) =>
                  role.toLowerCase() === 'itsupport' ||
                  role.toLowerCase() === 'processmanager' ||
                  role.toLowerCase() === 'processmanagerbackup'
              ) > -1
            "
          >
            <v-dialog v-model="roleImpersonationDialog" persistent max-width="400">
              <template v-slot:activator="{ props: activatorProps }">
                <v-btn v-bind="activatorProps" color="green" class="ml-2 white--text">Role Impersonation</v-btn>
              </template>
              <div style="overflow:auto">
                <v-toolbar color="blue-lighten-4" height="40" window>
                  <span></span>
                  <v-spacer></v-spacer>
                  <v-btn @click="roleImpersonationDialog = false" icon>
                    <v-icon color="error">mdi-close-circle</v-icon>
                  </v-btn>
                </v-toolbar>
                <role-impersonation :mocId="moc.mocId"></role-impersonation>
              </div>
            </v-dialog>
          </v-col>
          <v-col cols="12" v-if="showCloseStrandBtn()">
            <v-row dense justify="end">
            <v-dialog v-model="closedStrandedJustificationMOCDialog" persistent max-width="600px">
              <template v-slot:activator="{ props: activatorProps }">
                <v-btn dark v-bind="activatorProps" color="error" class="ma-2">{{ $t('Mark as Closed Stranded') }}</v-btn>
              </template>
              <v-card>
                <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
                <v-card-text class="text-h6 font-weight-bold">{{ $t('This MOC will be marked as Closed Stranded') }}</v-card-text>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="8">
                        <v-form ref="closedVoidMo" autocomplete="off">
                          <v-text-field
                            v-model="closedStrandedJustificationMOC"
                            variant="underlined"
                            name="closedStrandedJustificationMOC"
                            placeholder="Provide the link to the approved Enterprise MOC"                            
                            auto-grow                            
                          ></v-text-field>
                        </v-form>
                      </v-col>
                      <v-col cols="4">
                        <v-btn
                          :disabled="!closedStrandedJustificationMOC"
                          text
                          @click="validateClosedStrandedJustificationMOC()"
                        >
                          {{ $t('Validate_URL') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="info"
                    text
                    @click="
                      closedStrandedJustificationMOC = '';
                      closedStrandedJustificationMOCDialog = false;
                      validStrandedJustificationMOC = false
                    "
                    >{{ $t('Cancel') }}</v-btn
                  >

                  <!-- inner dialog -->
                  <v-dialog v-model="closedStrandedConfirmDialog" persistent max-width="600px">
                    <template v-slot:activator="{ props: activatorProps }">
                      <v-btn color="info" text v-bind="activatorProps" :disabled="!hasvalidClosedStrandedJustificationMOC">{{
                        $t('Strand')
                      }}</v-btn>
                    </template>
                    <v-card>
                      <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
                      <v-card-text class="text-h5">
                        {{ mocVoidStrandedMessage() }}
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="error"
                          text
                          @click="
                            closedStrandedJustificationMOC = '';
                            closedStrandedConfirmDialog = false;
                            closedStrandedJustificationMOCDialog = false;
                            validStrandedJustificationMOC = false
                          "
                          >{{ $t('Cancel') }}</v-btn
                        >
                        <v-btn color="primary" text @click="submitStranded()">{{ $t('Confirm') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <!-- /inner dialog -->
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <toaster ref="toaster"></toaster>
    <loading-dialog ref="loadingDialog"></loading-dialog>
  </div>
</template>

<script>
import { AdvanceType } from '@/common/systemTypes'
import { mapState } from 'vuex'
import { FormStatus, Roles } from '@/common/'
import AdminService from '@/services/admin.service'
import QARelationshipService from '@/services/qarelationship.service'
import RoleImpersonation from '@/components/developer/RoleImpersonation'
import MOCService from '@/services/moc.service'
import Toaster from '@/components/Toaster'
import LoadingDialog from '@/components/mocForm/LoadingDialog'

export default {
  name: 'SupportTools',
  data: () => ({
    taskRelationshipReport: false,
    questionsComplete: false,
    taskRelationshipReportLoading: false,
    fatReportLoading: false,
    roleImpersonationDialog: false,
    closedStrandedJustificationMOCDialog: false,
    closedStrandedJustificationMOC: '',
    closedStrandedConfirmDialog: false,
    strandConfirmMessage: 'MOC ID will be marked as Closed Stranded.',
    validStrandedJustificationMOC: false   
  }),
  components: {
    RoleImpersonation,
    Toaster,
    LoadingDialog
  },
  props: {
    moc: {
      type: Object
    }
  },
  methods: {
    areQuestionsCompleted: function () {
      if ((this.moc.answeredQuestions || []).length > 0) {
        let inQuestions = [...this.moc.answeredQuestions]
        if (inQuestions) {
          let unansweredQuestions = inQuestions.filter((q) => {
            return (q.required !== false && q.answers.length === 0) || q.answers === null
          })

          if (unansweredQuestions.length === 0) {
            this.questionsComplete = true
          } else {
            this.questionsComplete = false
          }
        }
      } else {
        this.questionsComplete = true
      }
    },
    downloadFATRelationshipReport() {
      this.fatReportLoading = true
      QARelationshipService.getProcessedMOCRelationship(this.moc.mocId, this.moc.changeType, this.moc.answeredQuestions)
        .then((response) => {
          return AdminService.getTaskRelationshipReportFromMocConfig({
            qaRelationships: response,
            questions: this.moc.communityData.questions,
            tasks: this.moc.communityData.tasks,
            communityAbbreviation: this.moc.communityData.communityAbbreviation
          })
        })
        .catch((e) => {
          this.$refs.toaster.pop('error', 'getMOCRelationships: ' + e)
        })
        .finally(() => {
          this.fatReportLoading = false
        })
    },
    downloadTaskRelationshipReport() {
      this.taskRelationshipReportLoading = true
      QARelationshipService.getQARelationshipFromMoc(this.moc.mocId)
        .then((response) => {
          return AdminService.getTaskRelationshipReportFromMocConfig({
            qaRelationships: response,
            questions: this.moc.communityData.questions,
            tasks: this.moc.communityData.tasks,
            communityAbbreviation: this.moc.communityData.communityAbbreviation
          })
        })
        .catch((e) => {
          this.$refs.toaster.pop('error', 'getQARelationshipFromMoc: ' + e)
        })
        .finally(() => {
          this.taskRelationshipReportLoading = false
        })
    },
    clearImpersonatedRoles() {
      sessionStorage.removeItem(this.moc.mocId)
      this.$router.go(0)
    },

    mocVoidStrandedMessage() {
      return `${this.moc.mocId} will be marked as Closed Stranded.`
    },

    validateClosedStrandedJustificationMOC() {
        //must be from ENT community        
        const justificationMOCId = this.closedStrandedJustificationMOC.substring(this.closedStrandedJustificationMOC.lastIndexOf('/')+1);
        const justificationMOCCommunity = justificationMOCId.substring(0,justificationMOCId.indexOf('-'));
        if(justificationMOCCommunity && justificationMOCCommunity.toLowerCase()==='ent')
        {
        MOCService.getMocStatus(justificationMOCId)
          .then((result) => {
            if (result.value === FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value) {
              this.validStrandedJustificationMOC = true
            }
            else{
          this.$refs.toaster.pop('error', 'Provide the link to the approved Enterprise MOC.')
        }
          })
          .catch((e) => {
            this.$refs.toaster.pop('error', 'fetchMocStatus: ' + e)
          })
        }
        else{
          this.$refs.toaster.pop('error', 'Provide the link to the approved Enterprise MOC.')
        }
      
    },
    submitStranded() {
      this.moc.closedStrandedReason = { justification: this.closedStrandedJustificationMOC }
      const data = this.moc
      this.$refs.loadingDialog.show()
      MOCService.save(this.moc, AdvanceType.CLOSESTRAND)
        .then((result) => {
          if (!result.success) {
            throw new Error(result.message)
          }
          this.closedVoidReasonDialog = false
          this.$refs.loadingDialog.hide({ redirect: true, message: this.$t('Success_SubmitStrandedSaved') })
        })
        .catch((e) => {
          this.$refs.loadingDialog.error({ metadata: 'submitStranded', error: e, message: this.$t('Error_ClosedStranded') })
        })
        .finally(() => {
          this.isSaving = false
        })
    },
    showCloseStrandBtn(){

      if (this.moc.status.value === FormStatus.properties[FormStatus.NEW].value ||
      this.moc.status.value === FormStatus.properties[FormStatus.CLOSED].value ||
      this.moc.status.value === FormStatus.properties[FormStatus.CLOSEDVOIDED].value ||
      this.moc.status.value === FormStatus.properties[FormStatus.CLOSEDREJECTED].value ||
      this.moc.status.value === FormStatus.properties[FormStatus.CLOSEDSTRANDED].value) {
        return false;

      }
      else{
        return true;
      }

}

  },
  computed: {
    ...mapState('currentUserAdminRoles', ['adminRoles']),
    currentQuestions: function () {
      if (this.moc) {
        if (this.moc.status.value === FormStatus.properties[FormStatus.NEW].value) {
          if ((this.moc.communityData.questions || []).length < 1) {
            return null
          }
          return [...this.moc.communityData.questions].sort((a, b) => a.order - b.order)
        }

        if (this.moc.answeredQuestions) {
          return this.moc.answeredQuestions
        }
      }
      return null
    },
    impersonatedRoles() {
      const result = sessionStorage.getItem(this.moc.mocId)
      if (!result) {
        return []
      }
      const roles = result ? JSON.parse(result) : []
      return roles
        .map((r) => Roles.properties[r])
        .filter((r) => r)
        .map((r) => r.name)
        .join(', ')
    },
    hasvalidClosedStrandedJustificationMOC: function () {
      return this.validStrandedJustificationMOC
    }
  },
  created() {
    this.areQuestionsCompleted()
  },
  watch:{
    closedStrandedJustificationMOC(){
      this.validStrandedJustificationMOC = false
    }

  }
}
</script>

<style scoped>

.text-button { 
   background-color: transparent !important;   
}

</style>
